import { render, staticRenderFns } from "./EnderecoV2.vue?vue&type=template&id=1448f2fa&"
import script from "./EnderecoV2.vue?vue&type=script&lang=js&"
export * from "./EnderecoV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports